import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router'
import { SimpleStorageService } from 'app/services/storage/simple-storage.service';
declare const analytics
@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompleteComponent implements OnInit {

  constructor(
    private router: Router,
    private simpleStorageService: SimpleStorageService,
  ) {
    if (this.simpleStorageService.getSimple('purchaseAmount') !== undefined) {
      analytics.track('purchase completed', {
        section: 'onboarding',
        revenue: this.simpleStorageService.getSimple('purchaseAmount'),
        value: this.simpleStorageService.getSimple('purchasedItems'),
        step: 'step 3'
      });
    }
  }

  ngOnInit(): void {
  }

  openHub() {
    this.router.navigate(["/kryptomons"])
  }

}
